import Modal from 'components/Modal'
import styled from 'styled-components'
import { color, screenWidth } from 'utils'

export const Wrapper = styled(Modal)`
  max-width: 480px;
  background: ${color('dark800')};
  border-radius: 0.5rem;

  img {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;

    @media only screen and (max-width: ${screenWidth('sm')}) {
      width: 100%;
    }
  }
`

export const Content = styled.main`
  padding: 1rem;
  color: ${color('white')};

  h1 {
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 150%;
  }
`

export const Footer = styled.footer`
  margin: 1rem 1rem 2rem 1rem;

  > button {
    width: 100%;
  }
`
